import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { TaxPayerDetailsDto } from "./TaxPayerDetailsDto";

interface UseGetFulfilmentTaxPayersParams {
    levyId: string;
    year: number;
}

export function useGetFulfilmentTaxPayers(
    params?: UseGetFulfilmentTaxPayersParams,
) {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();

    const query = useQuery<TaxPayerDetailsDto[]>({
        queryKey: ["useGetFulfilmentTaxPayers", workspaceId, params],
        queryFn: async () => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/fulfilments/${params?.levyId}/years/${params?.year}/tax-payers`,
                { headers },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!params && !!workspaceId,
        initialData: [],
        meta: {
            resourceName: t("errors.resourceName.fulfilmentTaxPayers"),
        },
    });

    return query;
}
